import { StyleSheet, Font } from "@react-pdf/renderer";

// Registrasi font
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxP.ttf" // Regular
    },
    {
      src: "https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc9.ttf", // Bold
      fontWeight: "bold"
    }
  ]
})

export const stylePdf = StyleSheet.create({
    page: {
        padding: 15
    },
    title: {
        fontSize: 15,
        marginBottom: 10,
        textAlign: "center",
        fontFamily: "Roboto"
    },
    date: {
        fontSize: 10,
        marginBottom: 10,
        textAlign: "left",
        fontWeight: "bold",
        fontFamily: "Roboto"
    },
    table: {
        display: "flex",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000"
    },
    tableRow: {
        flexDirection: "row"
    },
    tableHeader: {
        flexDirection: "row",
        backgroundColor: "#F8C308"
    },
    tableCol: {
        flex: 1,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
        padding: 2
    },
    tableCell: {
        margin: 2,
        fontSize: 6,
        fontFamily: "Roboto",
        textAlign: "left"
    },
    headerText: {
        margin: 2,
        fontSize: 6,
        fontWeight: "bold",
        fontFamily: "Roboto"
    }
})